export default __webpack_public_path__ + "9fb2daa1a0d518dba35dba466ec7b62f.svg";